import { render, staticRenderFns } from "./dialog-family-group-create.component.vue?vue&type=template&id=6eec60a8"
import script from "./dialog-family-group-create.component.vue?vue&type=script&lang=ts"
export * from "./dialog-family-group-create.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports